import { useEffect, useState } from 'react';

import { useGetCartId } from '@app/context/CartIdProvider/CartIdProvider';
import { pushPerpetualEcommerceEvent } from '@app/helpers/tracking';
import { useFireOnce } from '@app/hooks/useFireOnce';
import useGTMTracking from '@app/hooks/useGTMTracking';
import useSimpleCart from '@app/hooks/useSimpleCart';

import BillingAddress from './BillingAddress';
import ShippingBillingAddress from './ShippingBillingAddress';

const Address = () => {
  const { cartId } = useGetCartId();
  const { loading, isVirtual, prices, appliedCoupons, items, storeConfig } =
    useSimpleCart();
  const [addShippingInfoEventPushed, setAddShippingInfoEventPushed] =
    useState<boolean>(false);
  const fireEventOnce = useFireOnce();

  useEffect(() => {
    if (!addShippingInfoEventPushed) {
      fireEventOnce(() => {
        pushPerpetualEcommerceEvent('add_shipping_info', {
          cart_id: cartId,
          currency: prices?.grandTotal?.currency,
          value: prices?.grandTotal?.value,
          coupons: appliedCoupons,
          items: items?.map((item) => ({
            // item_id/item_name should come from the parent product,
            // but it's not available in the cart item data yet.
            // @TODO [ECOM-85, ECOM-84]
            item_id: item?.product?.sku,
            item_name: item?.product?.name,
            sku_id: item?.product?.sku,
            sku_name: item?.product?.name,
            sdbs_id: item?.product?.sdbsId,
            price: item?.prices?.price.value || 0,
            quantity: item?.quantity,
          })),
        });
      });
    }
    setAddShippingInfoEventPushed(true);
  }, [
    cartId,
    prices,
    appliedCoupons,
    items,
    setAddShippingInfoEventPushed,
    addShippingInfoEventPushed,
    fireEventOnce,
  ]);

  useGTMTracking({ step: 'address', items, prices, storeConfig });

  if (loading || !cartId) return null;

  return isVirtual ? (
    <BillingAddress cartId={cartId} />
  ) : (
    <ShippingBillingAddress cartId={cartId} />
  );
};

export default Address;
